export const sliceName = 'institutions'
